import React from "react";
import { useTranslate } from "../src/hooks/useTranslate";
import { Button, ButtonView } from "./Button";
import SvgArrowDown from "./icons/SvgArrowDown";
import { Tooltip } from "react-tooltip";

export interface PillsProps {
    pills: {
        label: string
        anchor?: string
    }[] 
}

export const Pills: React.FunctionComponent<PillsProps> = ({
    pills,
}) => {
    const translate = useTranslate()

    if(!pills.length)
    {
        return <></>;
    }

    return <div className="pills">
            {pills.map((item, i) => (
                <div className='pills-in' data-tooltip-content={ translate('prejit') }>
                    <Button
                        key={i}
                        view={ButtonView.tabs}
                        
                        onClick={() => document.getElementById(item.anchor!)?.scrollIntoView({behavior: 'smooth'})}
                        icon={<SvgArrowDown/>}
                    >
                            {item.label}
                    </Button>
                </div>
            ))}
            <Tooltip anchorSelect=".pills-in" />
    </div>;
}
